<h1 class="h5">Account configuration</h1>
<div class="row g-1 g-lg-3">

  <!-- Change Password -->
  <div class="col-lg-6">
    <div class="accordion h-100" id="accordion-password">
      <div class="accordion-item border-0 shadow h-100">
        <h2 class="accordion-header" id="heading-password">
          <button class="accordion-button fw-bold collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapse-password" aria-expanded="false" aria-controls="collapse-password">
            <i class="bi bi-key me-1"></i> Change Password
          </button>
        </h2>
        <div id="collapse-password" class="accordion-collapse collapse" aria-labelledby="heading-password"
             data-bs-parent="#accordion-password">
          <div class="accordion-body">
            <p class="small">You will need to confirm the password change.</p>
            <form [formGroup]="formPassword" (ngSubmit)="onPasswordSubmit(formPasswordDirective)" #formPasswordDirective="ngForm">
              <div class="mb-2">
                <label class="form-label small fw-bold">New Password</label>
                <input type="password" class="form-control form-control-sm" formControlName="password">
                <app-form-error [formError]="formPasswordError" formFieldName="password"></app-form-error>
              </div>
              <div class="mb-2">
                <label class="form-label small fw-bold">Confirm Password</label>
                <input type="password" class="form-control form-control-sm" formControlName="passwordConfirm">
                <app-form-error [formError]="formPasswordError" formFieldName="passwordConfirm"></app-form-error>
              </div>
              <div class="text-end">
                <button type="submit" class="btn btn-sm btn-primary fw-bold">Update</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Timezone Configuration -->
  <div class="col-lg-6">
    <div class="accordion h-100" id="accordion-timezone">
      <div class="accordion-item border-0 shadow h-100">
        <h2 class="accordion-header" id="heading-timezone">
          <button class="accordion-button fw-bold collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapse-timezone" aria-expanded="false" aria-controls="collapse-timezone">
            <i class="bi bi-clock me-1"></i> Timezone Configuration
          </button>
        </h2>
        <div id="collapse-timezone" class="accordion-collapse collapse" aria-labelledby="heading-timezone"
             data-bs-parent="#accordion-timezone">
          <div class="accordion-body">
            <p class="small">You can change the default timezone for displaying reports. However, this will not affect
              the reference timezone used for billing. The default time zone of our platform is Europe/Paris,
              which is also the billing reference: keep the platform default if you want the report figures to
              match your invoices. Daylight saving time is applied automatically, following the rules of the
              first city listed in each option.
            </p>
            <form [formGroup]="formTimezone" (ngSubmit)="onTimezoneSubmit()">
              <div class="mb-2">
                <label class="form-label small fw-bold">Select Timezone</label>
                <select id="gmt" class="form-select form-select-sm" formControlName="timezone">
                  <option value="">Platform default — Europe/Paris (billing timezone)</option>
                  <option value="-12">(GMT -12:00) Baker Island</option>
                  <option value="-11">(GMT -11:00) Midway Island, Samoa</option>
                  <option value="-10">(GMT -10:00) Hawaii</option>
                  <option value="-9">(GMT -9:00) Alaska</option>
                  <option value="-8">(GMT -8:00) Pacific Time (US &amp; Canada)</option>
                  <option value="-7">(GMT -7:00) Mountain Time (US &amp; Canada)</option>
                  <option value="-6">(GMT -6:00) Central Time (US &amp; Canada)</option>
                  <option value="-5">(GMT -5:00) Eastern Time (US &amp; Canada), Bogota</option>
                  <option value="-4">(GMT -4:00) Atlantic Time (Canada), Caracas</option>
                  <option value="-3">(GMT -3:00) Buenos Aires, Greenland</option>
                  <option value="-2">(GMT -2:00) South Georgia/Sandwich Islands</option>
                  <option value="-1">(GMT -1:00) Azores, Cape Verde</option>
                  <option value="0">(GMT 0:00) London, Lisbon</option>
                  <option value="1">(GMT +1:00) Paris, Berlin, Madrid, Rome</option>
                  <option value="2">(GMT +2:00) Athens, Cairo, Jerusalem</option>
                  <option value="3">(GMT +3:00) Moscow, Nairobi, Riyadh</option>
                  <option value="4">(GMT +4:00) Dubai, Baku, Yerevan</option>
                  <option value="5">(GMT +5:00) Karachi, Tashkent</option>
                  <option value="6">(GMT +6:00) Dhaka, Astana</option>
                  <option value="7">(GMT +7:00) Bangkok, Hanoi, Jakarta</option>
                  <option value="8">(GMT +8:00) Beijing, Singapore, Perth</option>
                  <option value="9">(GMT +9:00) Tokyo, Seoul, Yakutsk</option>
                  <option value="10">(GMT +10:00) Sydney, Vladivostok</option>
                  <option value="11">(GMT +11:00) Solomon Islands, New Caledonia</option>
                  <option value="12">(GMT +12:00) Auckland, Fiji</option>
                  <option value="13">(GMT +13:00) Tonga, Samoa</option>
                  <option value="14">(GMT +14:00) Line Islands</option>
                </select>
              </div>
              <div class="text-end">
                <button type="submit" class="btn btn-sm btn-primary fw-bold">SAVE</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- Newsletter and Notification Preferences -->
  <div class="col-lg-6">
    <div class="accordion h-100" id="accordion-notifications">
      <div class="accordion-item border-0 shadow h-100">
        <h2 class="accordion-header" id="heading-notifications">
          <button class="accordion-button fw-bold collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapse-notifications" aria-expanded="false" aria-controls="collapse-notifications">
            <i class="bi bi-envelope-paper me-1"></i> Newsletter and Notification Preferences
          </button>
        </h2>
        <div id="collapse-notifications" class="accordion-collapse collapse" aria-labelledby="heading-notifications"
             data-bs-parent="#accordion-notifications">
          <div class="accordion-body">
            <form>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="newsletter">
                <label class="form-check-label" for="newsletter">Newsletter Subscription</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="offers">
                <label class="form-check-label" for="offers">Offer Notifications</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="payments">
                <label class="form-check-label" for="payments">Payment Notifications</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="urgent">
                <label class="form-check-label" for="urgent">Urgent Notifications</label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="partners">
                <label class="form-check-label" for="partners">Special Offers from our Partners</label>
              </div>
              <div class="text-end mt-2">
                <button type="submit" class="btn btn-sm btn-primary fw-bold">SAVE</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Two-Factor Authentication -->
  <div class="col-lg-6">
    <div class="accordion h-100" id="accordion-2fa">
      <div class="accordion-item border-0 shadow h-100">
        <h2 class="accordion-header" id="heading-2fa">
          <button class="accordion-button fw-bold collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapse-2fa" aria-expanded="false" aria-controls="collapse-2fa">
            <i class="bi bi-shield-lock me-1"></i> Two-Factor Authentication
          </button>
        </h2>
        <div id="collapse-2fa" class="accordion-collapse collapse" aria-labelledby="heading-2fa"
             data-bs-parent="#accordion-2fa">
          <div class="accordion-body">
            <p class="small">Enhance the security of your account by enabling two-factor authentication.</p>
            <form>
              <div class="mb-2">
                <label class="form-label small fw-bold">Phone Number</label>
                <div class="input-group">
                  <!-- Select for country codes -->
                  <select class="form-select form-select-sm" id="country-code">
                    <option value="+1">🇺🇸 +1 (USA)</option>
                    <option value="+33" selected="">🇫🇷 +33 (France)</option>
                    <option value="+44">🇬🇧 +44 (UK)</option>
                    <option value="+49">🇩🇪 +49 (Germany)</option>
                    <option value="+91">🇮🇳 +91 (India)</option>
                    <option value="+81">🇯🇵 +81 (Japan)</option>
                  </select>
                  <!-- Phone input -->
                  <input type="tel" class="form-control form-control-sm" id="phone-number"
                         placeholder="Enter your phone number">
                  <span class="input-group-text bg-success d-none border-0" id="verified-check">
                                    <i class="bi bi-check-circle-fill text-white"></i>
                                </span>
                </div>
              </div>
              <div class="text-end">
                <button type="button" class="btn btn-sm btn-primary fw-bold" id="verify-btn">VERIFY</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
